
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  registerUserFormButton: {
    id: "RegisterUserForm.button",
    defaultMessage: "Register now",
  },
});

export default MESSAGES;